import React from "react";
import './RedQuickInfiniteScrollList.scss';

function sideScroll(element, direction, speed, distance, step) {
    let scrollAmount = 0;
    var slideTimer = setInterval(() => {
        if (direction == 'left') {
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
            window.clearInterval(slideTimer);
        }
    }, speed);
}


// class Card extends React.Component {
//     constructor(props) {
//         super(props);
//     }

//     render() {
//         return (
//             <div className={"card " + this.props.classes}>
//                 <div className="card-img-container">
//                     <span className="card-img-text">Not available</span>
//                 </div>
//                 <div className="card-text-container">
//                     <div className="card-title-block">
//                         <span className="card-title">{this.props.title}</span>
//                         <span className="card-subtitle">City, NE</span>
//                     </div>
//                     <div className="card-info-container">
//                         <div className="icon-container__horizontal">
//                             <div className="icon-group">
//                                 <i className="fas fa-users"></i> <span className="icon-text">42,389</span>
//                             </div>
//                             <div className="icon-group">
//                                 <i className="fas fa-user-check"></i> <span className="icon-text">6.8%</span>
//                             </div>
//                             <div className="icon-group">
//                                 <i className="fas fa-dollar-sign"></i> <span className="icon-text">32,000</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }




interface CardContainerProps {
    items: any[],
    itemsPerSlide: number
}
interface CardContainerState {
    scrollPos: number,
    disableScroll: boolean,
    scrollWidth: number,
    clonesWidth: number
}
export class RedQuickInfiniteScrollList extends React.Component<CardContainerProps, CardContainerState> {
    scrollContainerRef: React.RefObject<unknown>;
    constructor(props) {
        super(props);
        this.state = {
            disableScroll: false,
            scrollWidth: 0,
            scrollPos: 1,
            clonesWidth: 0,
        }
        this.scrollContainerRef = React.createRef();
        this.handleScroll = this.handleScroll.bind(this);
        this.scrollNext = this.scrollNext.bind(this);
        this.scrollPrev = this.scrollPrev.bind(this);
        this.setScroll = this.setScroll.bind(this);
        this.getClonesWidth = this.getClonesWidth.bind(this);
        this.reCalc = this.reCalc.bind(this);
    }

    reCalc() {
        let scrollPos = this.state.scrollPos;
        let scrollWidth = window.innerWidth;// this.scrollContainerRef.current.clientWidth;
        let clonesWidth = this.getClonesWidth();

        if (scrollPos <= 0) {
            scrollPos = 1;
        }
        this.setState({
            scrollPos: scrollPos,
            scrollWidth: scrollWidth,
            clonesWidth: clonesWidth,
        });
    }

    handleScroll(e) {
        const container = e.currentTarget;
        const scrollWidth = window.innerWidth;
        const clonesWidth = this.getClonesWidth();
        let scrollPos = container.scrollLeft;
        let scrollPosAdd;
        container.clientWidth > clonesWidth ? scrollPosAdd = container.clientWidth : scrollPosAdd = clonesWidth;

        // if (!this.state.disableScroll) {
        //     if (scrollPos + scrollPosAdd >= scrollWidth) {
        //         // this.setScroll(
        //         //     // The math floor value helps smooth out the scroll jump, 
        //         //     // I don't know why that particular value works, but it does 
        //         //     // Same goes for the other setScroll call below
        //         //     container, 1 + Math.floor(scrollPosAdd / 12.09)
        //         // );
        //         // this.setState({
        //         //     disableScroll: true,
        //         // });
        //     } else if (scrollPos <= 0) {
        //         this.setScroll(
        //             container, 
        //             scrollWidth - clonesWidth - Math.floor(scrollPosAdd / 12.09)
        //         );
        //         this.setState({
        //             disableScroll: true,
        //         });
        //     }
        // }

        // this.setState({
        //     scrollWidth: scrollWidth,
        //     scrollPos: container.scrollLeft,
        // });
    }

    getClonesWidth() {
        const clones = this.scrollContainerRef.current.getElementsByClassName('is-clone');
        let clonesWidth = 0;
        for (let i = 0; i < clones.length; i++) {
            clonesWidth += clones[i].clientWidth;
        }
        return clonesWidth;
    }

    setScroll(element, pos) {
        element.scrollLeft = pos;
        this.setState({
            scrollPos: element.scrollLeft,
        });
    }

    scrollNext(e) {
        const container = e.currentTarget.previousSibling;
        sideScroll(container, 'right', 10, 272, 10);
    }

    scrollPrev(e) {
        const container = e.currentTarget.nextSibling;
        sideScroll(container, 'left', 10, 272, 10);
    }



    componentDidUpdate(prevProps, prevState) {
        if (this.state.disableScroll) {
            window.setTimeout(function () {
                this.setState({
                    disableScroll: false,
                });
            }.bind(this), 40)
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.reCalc);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.reCalc);
    }

    render() {
        let { items, itemsPerSlide } = this.props;
        const scrollWidth = window.innerWidth;
        let clones = [...items].map((item: { color, component }, index: number) => {
            return <div className={`card is-clone ${index === 0 ? 'is-start' : ''}`} style={{
                width: (scrollWidth || 200) / itemsPerSlide
            }}>{React.cloneElement(item.component, {
                key: 'clonee' + index
            })}</div>
        });
        let updated_items = [...items].map((item: { color, component }, index: number) => {
            return <div className="card" style={{
                width: (scrollWidth || 200) / itemsPerSlide
            }}>{React.cloneElement(item.component, {
                key: 'updated_' + index
            })}</div>
        })

        return (
            <div className="infinite-scroll card-container">
                <div className="scroll scroll-prev" onClick={this.scrollPrev}>
                    <i className="fas fa-chevron-left"></i>
                </div>
                <div ref={this.scrollContainerRef} className="scrolling-wrapper" onScroll={this.handleScroll}>
                    {updated_items}
                    {clones}
                    {/* <Card title={'Card Number 1'} classes={""} />
                    <Card title={'Card Number 2'} />
                    <Card title={'Card Number 3'} />
                    <Card title={'Card Number 4'} />
                    <Card title={'Card Number 5'} />
                    <Card title={'Card Number 6'} />
                    <Card title={'Card Number 1'} classes={"is-clone is-start"} />
                    <Card title={'Card Number 2'} classes={"is-clone"} />
                    <Card title={'Card Number 3'} classes={"is-clone"} />
                    <Card title={'Card Number 4'} classes={"is-clone"} />
                    <Card title={'Card Number 5'} classes={"is-clone"} />
                    <Card title={'Card Number 6'} classes={"is-clone"} /> */}
                </div>
                <div className="scroll scroll-next" onClick={this.scrollNext}>
                    <i className="fas fa-chevron-right"></i>
                </div>
                {/*<div>  debugging values
          <div>ScrollPos:&nbsp;{this.state.scrollPos}</div>
          <div>ClonesWidth:&nbsp;{this.getClonesWidth()}</div>
          <div>ScrollWidth:&nbsp;{this.state.scrollWidth}</div>
        </div>*/}
            </div>
        )
    }
}
